/** Returns whether the subscription grants any paid entitlement. */
export function isPremiumSubscription(subscription) {
  return subscription?.entitlement === 'premium' && ['trialing', 'active'].includes(subscription?.status);
}

/** Returns whether a bundle or selected-hobby entitlement covers the requested hobby. */
export function hasPremiumForHobby(subscription, hobby) {
  if (!isPremiumSubscription(subscription)) return false;
  const entitlement = subscription?.entitlements?.find((item) => item.hobby === hobby)?.entitlement;
  if (entitlement) return entitlement === 'premium';
  if (subscription?.planKind === 'bundle') return true;
  if (subscription?.planKind === 'hobby') return subscription?.hobbyIds?.includes(hobby);
  return true;
}

/** Resolves the effective entry limit for a hobby, including unlimited entitlements. */
export function getHobbyUsageLimit(subscription, hobby) {
  return subscription?.limits?.find((limit) => limit.hobby === hobby) || null;
}

/** Calculates remaining free entries, preserving `null` for unlimited access. */
export function getRemainingEntries(subscription, hobby) {
  if (!subscription || hasPremiumForHobby(subscription, hobby)) return null;
  const limit = getHobbyUsageLimit(subscription, hobby);
  if (limit?.unlimited) return null;
  if (!limit || limit.remaining == null) return null;
  return Number(limit.remaining);
}

/** Performs the optimistic client-side limit check before opening a creation flow. */
export function canCreateEntries(subscription, hobby, amount = 1) {
  const remaining = getRemainingEntries(subscription, hobby);
  if (remaining == null) return true;
  return remaining >= amount;
}
